import { z } from "zod";

import { bank } from "./banks";

const residentSchema = z.object({
  nome: z.string().nullable().default(""),
  data_nascimento: z.string().nullable().default(""),
  profissão: z.string().nullable().default(""),
  cpf: z.string().nullable().default(""),
  casa_anterior: z.string().nullable().default(""),
  estado_civil: z.string().nullable().default(""),
});

const currentResidentSchema = z.object({
  nome: z.string().nullable().default(""),
  tipo: z.string().nullable().default(""),
  cnpj: z.string().nullable().default(""),
});

const propertySchema = z.object({
  endereco: z.string().nullable().default(""),
  cidade: z.string().nullable().default(""),
  uf: z.string().nullable().default(""),
  area_privativa: z.number().nullable().default(0),
  area_comum: z.number().nullable().default(0),
  area_total: z.number().nullable().default(0),
  inscricao_imobiliaria: z.string().nullable().default(""),
  matricula: z.string().nullable().default(""),
});

const firstBuySchema = z.object({
  proprietario: z.string().nullable().default(""),
  valor: z.number().nullable().default(0),
  data: z.string().nullable().default(""),
});

const consolidationSchema = z.object({
  data: z.string().nullable().default(""),
  valor: z.number().nullable().default(0),
});

const financingSchema = z.object({
  instituicao: z.string().nullable().default(""),
  valor: z.number().nullable().default(0),
  prazo: z.number().nullable().default(0),
  juros: z.number().nullable().default(0),
  programa: z.string().nullable().default(""),
});

const detailsSchema = z.object({
  recursos_proprios: z.number().nullable().default(0),
  recursos_fgts: z.number().nullable().default(0),
  desconto: z.number().nullable().default(0),
  parcela: z.number().nullable().default(0),
});

export const analyzeInfoSchema = z.object({
  moradores: z.array(residentSchema),
  atual_morador: currentResidentSchema,
  irregularidades: z.array(z.string()),
  imovel: propertySchema,
  info: z.object({
    primeira_compra: firstBuySchema,
    consolidacao: consolidationSchema,
    financiamento: financingSchema,
    detalhes: detailsSchema,
  }),
});

export const analyzesSchema = z.array(
  z.object({
    id: z.string(),
    titulo: z.string(),
    uf: z.string(),
    numero_do_leilao: z.string(),
    banco: bank,
    inscricao_imobiliaria: z.string().nullable().default(""),
    matricula: z.string().nullable().default(""),
    criado_em: z.coerce.date(),
  })
);

export const analyzeSchema = z.object({
  propriedade: z.object({
    uf: z.string(),
    banco: bank,
    numero_do_leilao: z.string(),
    inscricao_imobiliaria: z.string().nullable().default(""),
    matricula: z.string().nullable().default(""),
    cidade_descricao: z.string(),
  }),
  analise: z.object({
    titulo: z.string(),
    data: analyzeInfoSchema,
  }),
});
